import { Button, Image } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React, { useEffect, useState } from 'react';
import { bgDataAPI, bgGenerateContextAPI, chatAPI } from '../api/bd-controller';
import { openNotification } from '../meta/globalToaster';
import { Buffer } from 'buffer';
import { NOTIFICATION_TYPES } from '../const/notificationTypes';
import ReactMarkdown from 'react-markdown';

const BrandDiscoveryDataPage = () => {
  const [loading, setLoading] = useState(false);

  const [companyUniqueId, setCompanyUniqueId] = useState('');
  const [companyUrl, setCompanyUrl] = useState('');
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');

  const [response, setResponse] = useState<any>({});

  const [isContextUploaded, setIsContextUploaded] = useState(false);

  const checkBDResult = () => {
    setIsContextUploaded(false);

    if (companyUniqueId !== '' && companyUrl != '') {
      setResponse('');
      setLoading(true);
      bgDataAPI({ companyUniqueId: companyUniqueId, companyUrl: companyUrl }).then((data) => {
        try {
          if (data?.status) {
            if (data?.status === 200) {
              successSubmission(data);
            } else {
              failSubmission('Please try again later!');
            }
          } else {
            failSubmission('Please try again later!');
          }
        } catch (error) {
          failSubmission('Please try again later!');
        }
      });
    } else {
      failSubmission('All input fields Required.');
    }
  };

  const contextGenerating = () => {
    setIsContextUploaded(false);

    if (companyUniqueId !== '') {
      setLoading(true);
      bgGenerateContextAPI({ companyId: companyUniqueId }).then((data) => {
        try {
          if (data?.message) {
            setIsContextUploaded(true);
            openNotification({ type: NOTIFICATION_TYPES.SUCCESS, message: data?.message });

            setLoading(false);
          } else {
            failSubmission('Please try again later!');
          }
        } catch (error) {
          failSubmission('Please try again later!');
        }
      });
    } else {
      failSubmission('All input fields Required.');
    }
  };

  const getAnswerToContext = () => {
    if (companyUniqueId !== '' && question != '') {
      setAnswer('');
      setLoading(true);
      chatAPI({ companyUniqueId: companyUniqueId, question: question }).then((data) => {
        try {
          console.log(data);
          if (data?.answer) {
            setAnswer(data?.answer);
            setLoading(false);
          } else {
            failSubmission('Please try again later!');
          }
        } catch (error) {
          failSubmission('Please try again later!');
        }
      });
    } else {
      failSubmission('All input fields Required.');
    }
  };

  const successSubmission = (data: any) => {
    setLoading(false);

    setResponse(data);
  };

  const failSubmission = (message: any) => {
    setLoading(false);
    openNotification({ message });
  };

  return (
    <div className="container p-3">
      <div className="row">
        <div className="col-sm-12">
          <h3>Brand Discovery</h3>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <div className="row">
            <div className="col-sm-12 mt-3 mb-3">
              <p className="a-input-label">Company Unique Name</p>
              <TextArea
                value={companyUniqueId}
                onChange={(e) => {
                  setCompanyUniqueId(e?.target?.value);
                }}
                placeholder="Unique Name"
                rows={1}
                // autoSize={{ minRows: 3, maxRows: 5 }}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 mt-3 mb-3">
              <p className="a-input-label">Company URL</p>
              <TextArea
                value={companyUrl}
                onChange={(e) => {
                  setCompanyUrl(e?.target?.value);
                }}
                placeholder="Company URL"
                rows={1}
              />
            </div>
          </div>

          <div className="row d-flex justify-content-end">
            <div className="col-sm-6 mt-3">
              <Button
                type="primary"
                size="large"
                style={{ width: '100%' }}
                onClick={() => {
                  checkBDResult();
                }}
                loading={loading}
              >
                Check Result
              </Button>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4 mt-3 mb-3">
              <b>Company Logo</b>
            </div>
          </div>
          <div className="row">
            {response?.img_source_list &&
              response?.img_source_list?.map((item: any, index: any) => {
                return (
                  <div key={index} className="col-sm-4 mt-3 mb-3">
                    <Image width={200} src={item} />
                  </div>
                );
              })}
          </div>

          <div className="row">
            {response?.svg_source_list &&
              response?.svg_source_list?.map((item: any, index: any) => {
                const buff = new Buffer(item);
                const base64data = buff.toString('base64');

                return (
                  <div key={index} className="col-sm-4 mt-3 mb-3">
                    <Image width={200} src={`data:image/svg+xml;base64,${base64data}`} />
                  </div>
                );
              })}
          </div>

          <div className="row mt-5">
            <div className="col-sm-12">
              <h5>Source Links</h5>
            </div>
            <div className="col-sm-12">
              {response?.url_list &&
                response?.url_list?.map((item: any, index: any) => {
                  return (
                    <div className="row" key={index}>
                      <div className="col-sm-12">
                        <a href={item} target="_blank">
                          {item}
                        </a>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>

          <div className="row d-flex justify-content-end">
            <div className="col-sm-6 mt-3">
              <Button
                type="primary"
                size="large"
                style={{ width: '100%' }}
                onClick={() => {
                  contextGenerating();
                }}
                loading={loading}
              >
                Generate Context
              </Button>
            </div>
          </div>
        </div>
        {isContextUploaded && (
          <div className="col-sm-6">
            <div className="row">
              <div className="col-sm-12 mt-3 mb-3">
                <p className="a-input-label">Question</p>
                <TextArea
                  value={question}
                  onChange={(e) => {
                    setQuestion(e?.target?.value);
                  }}
                  placeholder="Question"
                  rows={3}
                  // autoSize={{ minRows: 3, maxRows: 5 }}
                />
              </div>
            </div>
            <div className="row d-flex justify-content-end">
              <div className="col-sm-6 mt-3">
                <Button
                  type="primary"
                  size="large"
                  style={{ width: '100%' }}
                  onClick={() => {
                    getAnswerToContext();
                  }}
                  loading={loading}
                >
                  Send
                </Button>
              </div>
            </div>

            <div className="col-sm-12 mt-5">
              {answer != '' && (
                <div className="result-div">
                  <ReactMarkdown>{answer}</ReactMarkdown>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandDiscoveryDataPage;
